'use strict';

import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';
import { appState } from './appState.js';
import { VarMgr } from './VarMgr.js';

export async function loadCreatePin() {
    const globalLock = await window.AppBridge.getGlobalLock();
    globalLock.set('reloadOnUnlock', true);

    const isPinForceChangeForm = VarMgr.get('isPinForceChangeForm');
    const showPinNotify = VarMgr.get('showPinNotify');
    const logOutUrl = VarMgr.get('logOutUrl');

    const onPinClose = async (finished, href) => {
        if (finished) {
            await ajaxWrapNew({
                method: 'POST',
                data: {
                    ajax: 1,
                    action: 'cryptAuthCLOSE',
                    href: href || ''
                },
                success: function(data) {
                    ResponseDispatcher.handle(data);
                },
                dataType : 'json'
            });
        } else {
            $('#icreatepin').show();
        }
    };

    $('.btn-createpin').on('click', function() {
        $('#icreatepin').hide();

        if (isPinForceChangeForm) {
            window.AppBridge.CreatePin({
                forceChange: true,
                onClose: onPinClose,
                globalAfterSave: true
            });
        } else {
            window.AppBridge.CreatePin({
                onClose: onPinClose,
                globalAfterSave: true
            });
        }
    });

    $('.btn-skip').on('click', function() {
        let action = $(this).data('action');
        if (action === 'pin-skip') {
            ajaxWrapNew({
                method: 'POST',
                data: {
                    ajax: 1,
                    action: 'cryptAuthSKIP',
                },
                success: function(data) {
                    ResponseDispatcher.handle(data);
                },
                dataType : 'json'
            });
        } else if (action === 'pin-logout') {
            document.dispatchEvent(new CustomEvent('urlTools_goSafe', { detail: { url: logOutUrl, type: 'assign' } }));
        }
    });

    if (showPinNotify) {
        const globalCryptConf = appState.getGlobalCryptConf();
        if (globalCryptConf && globalCryptConf.convert) {

        } else {
            $('.if-pinFinished').show();
            $('.if-pinConverting').hide();
        }

        $('body').on('click.pincreate', '.btn-close-successful', function() {
            onPinClose(true);
        });
        $('body').on('click.pincreate', 'a', function(event) {
            if (this.notpinsetnotify || $(this).closest('.pin-set-notification').length == 0) {
                this.notpinsetnotify = true;
                return;
            }
            event.preventDefault();
            event.stopPropagation();

            var href = $(this).attr('href');
            onPinClose(true, href);
        });
    }
}